import React from 'react';
import styled, { css } from 'styled-components';

import { isLightColor } from '@/utils/color';
import CheckIcon from '@/assets/svg/checkbox-tick.svg';
import { colors } from '@/constants/theme';

import { StockColorPickerProps, ColorOptionType } from './types';

function StockColorPicker({
  colors,
  selectedColors,
  onChange,
}: StockColorPickerProps) {
  const whiteColors: string[] = ['#ffffff', '#fff', 'rgb(255,255,255)'];

  const handleColorClick = (color: ColorOptionType) => {
    onChange?.(color);
  };

  return (
    <Component>
      {colors && colors.length !== 0 ? (
        colors.map((color, index) => {
          const isActive = selectedColors?.find(
            (searchColor) => searchColor.value === color.value
          );
          return (
            <Color
              key={index}
              color={color.hex}
              whiteColors={whiteColors}
              onClick={() => handleColorClick(color)}
            >
              {isActive ? (
                isLightColor(color.hex) ? (
                  <StyledCheckIcon isLight />
                ) : (
                  <StyledCheckIcon />
                )
              ) : null}
            </Color>
          );
        })
      ) : (
        <NoOptions>Нет опций</NoOptions>
      )}
    </Component>
  );
}

export default StockColorPicker;

const Component = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Color = styled.div<{ color: string; whiteColors: string[] }>`
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin: 0 16px 16px 0;

  ${({ color }) =>
    color &&
    css`
      background: ${color};
    `}

  ${({ color, whiteColors }) =>
    color &&
    whiteColors.includes(color.toLowerCase()) &&
    css`
      border: 2px solid #8b8b8b;

      svg {
        padding: 0;
      }
    `}
`;

const StyledCheckIcon = styled(CheckIcon)<{ isLight?: boolean }>`
  padding: 2px;
  width: 100%;
  height: 100%;

  path {
    fill: ${colors.white};
    stroke: ${colors.white};
  }

  ${({ isLight }) =>
    isLight &&
    css`
      path {
        fill: ${colors.black};
        stroke: ${colors.black};
      }
    `}
`;

const NoOptions = styled.p`
  font-size: 16px;
  line-height: 19px;
  color: ${(props) => props.theme.blue100};
`;
